// extracted by mini-css-extract-plugin
module.exports = {"theComp":"Freedom_theComp__NiLai","swiperTool":"Freedom_swiperTool__S99x_"};